import styled from 'styled-components';

import { color } from '~/assets/styles/colors';

export const Accordion = styled.div`
	color: ${color.black};
`;

export const AccordionHeading = styled.div`
`;

export const AccordionHeadingP = styled.p`
	padding: 0;
	margin: 0;
`;

export const AccordionHeadingSpan = styled.span`
`;

export const AccordionHeadingContainer = styled.div`
	display: flex;

	padding: 0;
	margin: 0;
	width: 100%;
	justify-content: space-between;
`;

export const AccordionHeadingContainerP = styled.div`
	display:block;
	width: 100%;

	text-align: left;

    flex-wrap: wrap; // Quebra a linha
    flex-direction: row; //Direção que você deseja
`;

export const AccordionContent = styled.div`
	&.show{
		height: 100%;
		opacity: 1;
	}

	height: 0;
	opacity: 0;
	display: flex;
	overflow: hidden;
	transition: all 60ms ease-in-out;
`;
